export default "__VITE_ASSET__C9kCSqpZ__"